import { Badge } from '../ui/badge';
import { cn } from '../../lib/utils';

export type MachineLifecycleStatus = 'DRAFT' | 'SCHEDULED' | 'LIVE' | 'ARCHIVED' | 'UNMANAGED';

const lifecycleConfig: Record<
  MachineLifecycleStatus,
  { label: string; className: string }
> = {
  DRAFT: {
    label: 'Draft',
    className: 'bg-muted text-muted-foreground border-transparent',
  },
  SCHEDULED: {
    label: 'Scheduled',
    className: 'bg-blue-100 text-blue-900 border-transparent dark:bg-blue-950 dark:text-blue-100',
  },
  LIVE: {
    label: 'Live',
    className: 'bg-rag-good/15 text-rag-good border-transparent',
  },
  ARCHIVED: {
    label: 'Archived',
    className: 'bg-secondary text-secondary-foreground border-transparent',
  },
  UNMANAGED: {
    label: 'Unmanaged',
    className: 'bg-amber-100 text-amber-950 border-transparent dark:bg-amber-950 dark:text-amber-100',
  },
};

interface MachineLifecycleBadgeProps {
  status: MachineLifecycleStatus;
  className?: string;
}

export function MachineLifecycleBadge({ status, className }: MachineLifecycleBadgeProps) {
  const config = lifecycleConfig[status] ?? lifecycleConfig.DRAFT;

  return (
    <Badge variant="outline" className={cn('font-normal', config.className, className)}>
      {config.label}
    </Badge>
  );
}

export function lifecycleStatusLabel(status: MachineLifecycleStatus): string {
  return lifecycleConfig[status]?.label ?? status;
}
